import { ROUTER_PATH } from "config/path";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const useHomeButton = ({
  setBeforeUnloadDisable,
}: {
  setBeforeUnloadDisable: (disable: boolean) => void;
}) => {
  // 임시 저장 모달
  const [openHomeModal, setOpenHomeModal] = useState(false);

  /**
   * @description HOME 버튼 클릭 이벤트 핸들러
   */
  const onClickHomeButton = () => {
    setOpenHomeModal(true);
  };

  const navigate = useNavigate();

  /**
   * @description Home 이동 함수
   */
  const goToHome = () => {
    setBeforeUnloadDisable(true);
    navigate(ROUTER_PATH.home);
  };

  return {
    openHomeModal,
    setOpenHomeModal,
    onClickHomeButton,
    goToHome,
  };
};

export default useHomeButton;
